"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterType = exports.ProductParameters = exports.ProductSize = exports.ProductColor = void 0;
var ProductColor;
(function (ProductColor) {
    ProductColor["RED"] = "RED";
    ProductColor["BLUE"] = "BLUE";
    ProductColor["GREEN"] = "GREEN";
})(ProductColor || (exports.ProductColor = ProductColor = {}));
var ProductSize;
(function (ProductSize) {
    ProductSize["XS"] = "XS";
    ProductSize["S"] = "S";
    ProductSize["M"] = "M";
    ProductSize["L"] = "L";
    ProductSize["XL"] = "XL";
    ProductSize["XXL"] = "XXL";
    ProductSize["XXXL"] = "XXXL";
})(ProductSize || (exports.ProductSize = ProductSize = {}));
var ProductParameters;
(function (ProductParameters) {
    ProductParameters["COLOR"] = "COLOR";
    ProductParameters["SIZE"] = "SIZE";
    ProductParameters["VOLUME"] = "VOLUME";
    ProductParameters["FLAVOUR"] = "FLAVOUR";
})(ProductParameters || (exports.ProductParameters = ProductParameters = {}));
var ParameterType;
(function (ParameterType) {
    ParameterType["DATE"] = "DATE";
    ParameterType["ENUM"] = "ENUM";
    ParameterType["STRING"] = "STRING";
    ParameterType["NUMBER"] = "NUMBER";
})(ParameterType || (exports.ParameterType = ParameterType = {}));
//# sourceMappingURL=parameter.js.map